import React, { Component } from "react";
import { Table, Button, Col, Row } from "antd";
import axios from "axios";
import PrintModal from '../components/PrintModal';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import "./Relatorios.css";

const { Column } = Table;

class OrdemServicosPrintModal extends Component {
    state = {
        listaRegistros: [],
        visualizar: false,
        carregando: false,
    }

    componentDidUpdate(propsAnte, stateAnte) {
        if (!stateAnte.visualizar && this.state.visualizar) {
            this.getListaRegistros();
        }
    }

    getListaRegistros = () => {
        this.setState({ carregando: true, listaRegistros: [] });

        const { buscaDataIni, buscaDataFim, buscaControle, buscaPessoa, buscaUsuario } = this.props.filtros;

        let dataIni = '';
        if ((buscaDataIni) && (buscaDataIni !== undefined)) {
            dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
        }
        let dataFim = '';
        if ((buscaDataFim) && (buscaDataFim !== undefined)) {
            dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
        }

        axios
            .get('/ordem_servicos', {
                params: {
                    print: true,
                    numero: buscaControle,
                    pessoa: buscaPessoa.key,
                    usuario: buscaUsuario.key,
                    dataIni,
                    dataFim,
                }
            })
            .then(response => {
                const { data } = response;
                this.setState({
                    listaRegistros: data.dados,
                    carregando: false,
                });
            })
            .catch(erro => {
                console.warn(erro);
                this.setState({
                    carregando: false,
                });
            });
    };

    onCancelar = () => {
        this.setState({
            visualizar: false
        })
    }

    onVisualizar = () => {
        this.setState({
            visualizar: true
        })
    }

    renderValor = (vlr, registro) => {
        return (
            <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
        );
    };

    renderData = (data) => {
        if (data) {
            const dataMoment = moment(data);
            return (
                <span>
                    {dataMoment.format('DD/MM/YYYY HH:mm')}
                </span>
            )
        } else {
            <span></span>
        }
    }

    renderSitOS = (sit) => {
        return (
            <span> {sit === 'ESP' ? 'ESPERA' : (sit === 'AGE' ? 'AGENDADO' : (sit === 'EXE' ? 'EXECUÇÃO' : (sit=== 'FIN' ? 'FINALIZADA' : (sit === 'ENT' ? 'ENTREGUE' : '') )))} </span>
        );
    };

    renderSitFinanc = (sit) => {
        return (
            <span> {sit === 'P' ? 'PAGO' : 'ABERTO'} </span>
        );
    };


    render() {
        const { listaRegistros, carregando, visualizar } = this.state;
        return (
            <span>
                <Button onClick={this.onVisualizar}>
                    Impressão
                </Button>

                <PrintModal
                    visible={visualizar}
                    onCancel={this.onCancelar}
                >
                    <div >
                        <div className="titulo">
                            Ordens de Serviços
                        </div>

                        <Row>
                            <Col xs={22} style={{ marginTop: 10, marginLeft: 20, textAlign: "right" }} >
                                <span style={{ fontWeight: "bold" }}>Qtde O.S: </span>
                                <span>{this.props.qtdeOS}</span>

                                <span style={{ fontWeight: "bold", marginLeft: 50 }}>Valor Total: </span>
                                <span>R$ {this.renderValor(this.props.totalOS)}</span>
                            </Col>
                        </Row>

                        <Table
                            pagination={false}
                            dataSource={listaRegistros}
                            className="tabela"
                            rowKey={(listaRegistros => listaRegistros.os_idf)}
                            loading={{
                                spinning: carregando,
                                tip: 'Carregando. Aguarde...',
                                size: "large"
                            }}
                        >
                            <Column
                                key="os_numero"
                                dataIndex="os_numero"
                                title="Número"
                                width={80}
                                align="center"
                                className="listaCadastro"
                            />
                            <Column
                                key="os_data_emissao"
                                dataIndex="os_data_emissao"
                                title="Emissão"
                                render={this.renderData}
                                width={150}
                                align="center"
                                className="listaCadastro"
                            />
                            <Column
                                key="pes_nome"
                                dataIndex="pes_nome"
                                title="Cliente"
                                width={150}
                                align="left"
                                className="listaCadastro"
                            />
                            <Column
                                key="os_descricao"
                                dataIndex="os_descricao"
                                title="Descrição"
                                width={100}
                                align="left"
                                className="listaCadastro"
                            />
                            <Column
                                key="usu_nome"
                                dataIndex="usu_nome"
                                title="Vendedor"
                                width={100}
                                align="left"
                                className="listaCadastro"
                            />
                            <Column
                                key="os_vlr_total"
                                dataIndex="os_vlr_total"
                                title="Valor Total"
                                render={this.renderValor}
                                width={90}
                                align="right"
                                className="listaCadastro"
                            />
                            <Column
                                key="tit_situacao"
                                dataIndex="tit_situacao"
                                title="Sit. Financ."
                                render={this.renderSitFinanc}
                                width={100}
                                align="center"
                                className="listaCadastro"
                            />
                            <Column
                                key="os_situacao"
                                dataIndex="os_situacao"
                                title="Sit. O.S"
                                render={this.renderSitOS}
                                width={100}
                                align="left"
                                className="listaCadastro"
                            />
                        </Table>
                    </div>

                </PrintModal>
            </span>
        );
    }
}

export default OrdemServicosPrintModal;



// WEBPACK FOOTER //
// ./src/relatorios/OrdemServicosPrintModal.js